/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import Vue from 'vue';
import axios from 'axios';
import hash from 'object-hash';

export default {
  API: {
    ANALYTICS_CHAT_FILTERS: '/chatAnalytics/chatFilters',
    ANALYTICS_CHAT_TOPICS: '/chatAnalytics/chatTopics',
    ANALYTICS_ALL_CONTACT_REASONS: '/chatAnalytics/allContactReasons',
    ANALYTICS_CHAT_PERFORMANCE: '/chatAnalytics/chatPerformance',
    ANALYTICS_CONTACT_REASONS: '/chatAnalytics/reasonsForContact',
    ANALYTICS_CONTACT_REASONS_DETAIL: '/chatAnalytics/reasonsForContactDetail',
    ANALYTICS_CONTACT_REASONS_TOPIC_TREMD: '/chatAnalytics/topicTrend',
    ANALYTICS_CONTACT_REASONS_TOPIC_MESSAGES: '/chatAnalytics/topicMessages',
    ANALYTICS_CONTACT_REASONS_TOPIC_MESSAEG_CONVERSATIONS: '/chatAnalytics/topicMessageConversations',
    ANALYTICS_CONTACT_REASONS_TOPIC_INTENTS: '/chatAnalytics/topicIntents',
    ANALYTICS_CONTACT_REASONS_TOPIC_ENTITIES: '/chatAnalytics/topicEntities',
    ANALYTICS_CONTACT_REASONS_TOPIC_CX_BREAKDOWN: '/chatAnalytics/topicCXBreakdown',
    ANALYTICS_CONTACT_REASONS_TOPIC_ANOMALIES: '/chatAnalytics/topicAnomaliesByDisplayName',
    ANALYTICS_CONTACT_REASONS_TOPIC_CONVERSATION: '/chatAnalytics/topicConversation',
    ANALYTICS_CONTACT_REASONS_TOPIC_CONVERSATION_DETAIL: '/chatAnalytics/topicConversationDetail',
    ANALYTICS_CONTACT_REASONS_MERGE_TOPICS: '/chatAnalytics/mergeTopics',
    ANALYTICS_CONTACT_REASONS_TOPIC_UPDATEBLACKLIST: '/chatAnalytics/updateBlacklist',
    ANALYTICS_CONTACT_REASONS_TOPIC_UPDATETOPICNAME: '/chatAnalytics/renameTopic',
    ANALYTICS_CONTACT_REASONS_TOPIC_BLACKLISTS_TOPICS: '/chatAnalytics/blacklistedTopics',
    ANALYTICS_CONTACT_REASONS_TOPIC_BLACKLISTS_MESSAGES: '/chatAnalytics/blacklistedMessages',
    ANALYTICS_CONTACT_REASONS_TOPIC_BLACKLISTS_MESSAGES_ADD: '/chatAnalytics/blacklistedMessagesAdd',
    ANALYTICS_CONTACT_REASONS_TOPIC_BLACKLISTS_MESSAGES_REMOVE: '/chatAnalytics/blacklistedMessagesRemove',
    ANALYTICS_CONTACT_REASONS_TOPIC_BLACKLISTS_TOPIC_MESSAGES_EXPORT: '/chatAnalytics/exportBlacklistedTopicMessages',
    

    ANALYTICS_CONTACT_REASONS_FETCH_BY_COMPANYID: '/chatAnalytics/fetchContactReasonsByCompanyId',
    ANALYTICS_CHAT_TOPICS_SEARCH_WITH_KEYWORD: '/chatAnalytics/chatTopicsSearchWithKeyword',
    ANALYTICS_CHAT_TOPICS_RELATIONS: '/chatAnalytics/topicRelations',
    ANALYTICS_RUN_STATS: '/chatAnalytics/runStats',
    ANALYTICS_MODEL_STATS: '/chatAnalytics/modelStats',
    ANALYTICS_TRAFFIC_MANAGER: '/chatAnalytics/trafficManager',
    ANALYTICS_METRICS: '/chatAnalytics/metrics',
    ANALYTICS_TRANSCRIPT_GET_TIME: '/chatAnalytics/getTranscriptSearchFilters',
    // ANALYTICS_TRANSCRIPT_GET_TIME: '/chatAnalytics/getTranscrirptSearchFilters',
    ANALYTICS_TRANSCRIPT_SEARCH: '/chatAnalytics/getTranscripts',
    ANALYTICS_METRIC_TRANSCRIPT_SEARCH: '/chatAnalytics/topicCXBreakdownTranscriptSearch',
    
    ANALYTICS_TOPIC_DISPLAY_NAME_LIST: '/chatAnalytics/getTopicDisplayNameList',
    ANALYTICS_TOPIC_RESPONSE_NAME_LIST: '/chatAnalytics/getTopicResponseNameList',
    ANALYTICS_RELATED_TOPIC_LIST: '/chatAnalytics/getRelatedTopicList',
    ANALYTICS_INTENT_NAME_LIST: '/chatAnalytics/getIntentNames',

    ANALYTICS_TRANSCRIPT_SUMMARY: '/chatAnalytics/getTranscriptContentSummary',
    ANALYTICS_TRANSCRIPT_EXPORT: '/chatAnalytics/exportTranscripts',
    ANALYTICS_ADD_TRANSCRIPT: '/chatAnalytics/addTranscript',
    ANALYTICS_REMOVE_TRANSCRIPT: '/chatAnalytics/removeTranscript',
    ANALYTICS_CONTACT_REASONS_LIST: '/chatAnalytics/getContactReasons',

    ANALYTICS_BES_BAS_PIE_CHART: '/homeDashboard/botSummaryPieChart',
    ANALYTICS_BES_BAS_LINE_CHART: '/homeDashboard/botSummaryLineChart',
    ANALYTICS_BES_BAS_WATERFALL_CHART: '/homeDashboard/botSignalDistribution',
    CONVER_VOL_LAST_30_DAYS: '/homeDashboard/vaConversationsVolume',
    CONVER_VOL_LAST_3_MOS: '/homeDashboard/vaConversationsVolumeLineChart',
    BES_BAS_CONTACT_REASONS_SUMMARY: '/homeDashboard/botBesBasForContactReasons',

    ANALYTICS_CONFIG_INTENTS_TO_HANDOFF: '/chatAnalytics/getConfigHandoffIntentList',
    ANALYTICS_CONFIG_INTENTS_TO_HANDOFF_UPDATE: '/chatAnalytics/updateConfigHandoffIntentList',
  },

  cachedHash: {},
  cancelTokens: [],

  getRequest(authUser, url, headers) {
    if (authUser.accessToken) {
      if (headers == null) headers = {};
      headers['Authorization'] = 'Bearer ' + authUser.accessToken;
      headers['Api-Configs'] = JSON.stringify(authUser.config.api.configs);
      if(authUser.sessionId) {
        headers['Auth-Host'] = authUser.authHost || "";
        headers['Auth-Session-Id'] = authUser.sessionId;
        headers['Auth-Product-Name'] = authUser.productName || "";
        headers['Auth-Options'] = authUser.authOptions || "";
      }

      return axios.get(url, { headers: headers, timeout: 300000 });
    } else {
      return null;
    }
  },

  postRequest(authUser, url, payload, headers) {
    if (authUser.accessToken) {
      if (headers == null) headers = {};
      headers['Authorization'] = 'Bearer ' + authUser.accessToken;
      headers['Api-Configs'] = JSON.stringify(authUser.config.api.configs);
      if(authUser.sessionId) {
        headers['Auth-Host'] = authUser.authHost || "";
        headers['Auth-Session-Id'] = authUser.sessionId;
        headers['Auth-Product-Name'] = authUser.productName || "";
        headers['Auth-Options'] = authUser.authOptions || "";
      }

      let cancelTokenKey = url;
      if (this.cancelTokens[cancelTokenKey]) {
        // cancel request
        this.cancelTokens[cancelTokenKey].cancel();
      }
      this.cancelTokens[cancelTokenKey] = axios.CancelToken.source();

      let options = {
        timeout: 300000, // timeout in 5 mins
        headers: headers,
        cancelToken: this.cancelTokens[cancelTokenKey].token,
      };

      return axios.post(url, payload, options);
    } else {
      return null;
    }
  },

  fetchChatTopics(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CHAT_TOPICS;
    return this.postRequest(authUser, url, payload);
  },

  fetchAllContactReasons(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_ALL_CONTACT_REASONS;
    return this.postRequest(authUser, url, payload);
  },

  fetchChatFilters(authUser) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CHAT_FILTERS;
    return this.getRequest(authUser, url);
  },

  fetchChatPerformance(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CHAT_PERFORMANCE;
    return this.postRequest(authUser, url, payload);
  },

  fetchBesBasPieChart(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_BES_BAS_PIE_CHART;
    return this.postRequest(authUser, url, payload);
  },
  fetchBesBasLineChart(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_BES_BAS_LINE_CHART;
    return this.postRequest(authUser, url, payload);
  },
  fetchBesBasWaterfallChart(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_BES_BAS_WATERFALL_CHART;
    return this.postRequest(authUser, url, payload);
  },
  fetchConverVolLast30DaysChartData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.CONVER_VOL_LAST_30_DAYS;
    return this.postRequest(authUser, url, payload);
  },

  fetchConverVolLast3mosChartData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.CONVER_VOL_LAST_3_MOS;
    return this.postRequest(authUser, url, payload);
  },

  fetchBesBasContactReasonsSummary(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.BES_BAS_CONTACT_REASONS_SUMMARY;
    return this.postRequest(authUser, url, payload);
  },

  fetchContactReasons(authUser, options, payload) {
    delete payload.topics;

    // log amplitude event
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS;
    let hashName = `fetchContactReasons`;
    let payloadHash = hash(payload);
    if ((options && options.forceRefresh) || this.cachedHash[hashName] != payloadHash) {
      this.cachedHash[hashName] = payloadHash;
      return new Promise(async (resolve) => {
        let res = await this.postRequest(authUser, url, payload);
        resolve(res);
      });
    } else {
      return new Promise(async (resolve) => {
        resolve(true);
      });
    }
  },

  fetchContactReasonsByCompanyId(authUser) {
    // log amplitude event
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_FETCH_BY_COMPANYID;
    return this.postRequest(authUser, url);
  },

  mergeContactReasonsTopics(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_MERGE_TOPICS;
    return this.postRequest(authUser, url, payload);
  },

  updateContactReasonTopicBlackList(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_UPDATEBLACKLIST;
    return this.postRequest(authUser, url, payload);
  },

  addContactReasonBlackListMessage(authUser, message) {
    let payload = {
      message: message,
      updatedBy: authUser.user.email,
    };
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_BLACKLISTS_MESSAGES_ADD;
    return this.postRequest(authUser, url, payload);
  },

  removeContactReasonBlackListMessage(authUser, message) {
    let payload = {
      message: message,
      updatedBy: authUser.user.email,
    };
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_BLACKLISTS_MESSAGES_REMOVE;
    return this.postRequest(authUser, url, payload);
  },

  updateTopicName(authUser, topicNameObject) {
    let payload = {
      newTopicDisplayName: topicNameObject.newTopicDisplayName,
      oldTopicDisplayName: topicNameObject.oldTopicDisplayName,
      topicsToMerge: topicNameObject.topicsToMerge,
      updatedBy: authUser.user.email,
    };
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_UPDATETOPICNAME;
    return this.postRequest(authUser, url, payload);
  },

  fetchContactReasonsTopicTrend(user, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_TREMD;
    return this.postRequest(user, url, payload);
  },

  fetchContactReasonsTopicMessages(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_MESSAGES + '?t=m';
    return this.postRequest(authUser, url, payload);
  },

  fetchContactReasonsTopicMessageConversations(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_MESSAEG_CONVERSATIONS + '?t=m';
    return this.postRequest(authUser, url, payload);
  },

  fetchContactReasonsTopicIntents(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_INTENTS + '?t=i';
    return this.postRequest(authUser, url, payload);
  },

  fetchContactReasonsTopicEntities(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_ENTITIES + '?t=e';
    return this.postRequest(authUser, url, payload);
  },

  fetchContactReasonsTopicCxBreakdown(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_CX_BREAKDOWN;
    return this.postRequest(authUser, url, payload);
  },

  fetchContactReasonsTopicAnomalies(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_ANOMALIES;
    return this.postRequest(authUser, url, payload);
  },

  fetchContactReasonsTopicConversations(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_CONVERSATION + `?mode=${payload.from ? payload.from : '0'}`;
    delete payload.from;
    return this.postRequest(authUser, url, payload);
  },

  fetchContactReasonsTopicConversationDetail(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_CONVERSATION_DETAIL;
    return this.postRequest(authUser, url, payload);
  },

  fetchContactReasonsBlackListsTopics(authUser) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_BLACKLISTS_TOPICS;
    return this.getRequest(authUser, url);
  },

  fetchContactReasonsBlackListsMessages(authUser) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_BLACKLISTS_MESSAGES;
    return this.getRequest(authUser, url);
  },

  fetchContactReasonsTopicRelations(user, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CHAT_TOPICS_RELATIONS;
    return this.postRequest(user, url, payload);
  },

  fetchContactReasonList(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_LIST;
    return this.postRequest(authUser, url, payload);
  },

  fetchTranscriptSearchTimeRange(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_TRANSCRIPT_GET_TIME;
    return this.postRequest(authUser, url, payload);
  },
  fetchTranscriptSearch(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_TRANSCRIPT_SEARCH;
    return this.postRequest(authUser, url, payload);
  },
  fetchMetricTranscriptSearch(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_METRIC_TRANSCRIPT_SEARCH;
    return this.postRequest(authUser, url, payload);
  },
  fetchTopicDisplayNameList(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_TOPIC_DISPLAY_NAME_LIST;
    return this.postRequest(authUser, url, payload);
  },
  fetchTopicResponseNameList(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_TOPIC_RESPONSE_NAME_LIST;
    return this.postRequest(authUser, url, payload);
  },
  fetchRelatedTopicList(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_RELATED_TOPIC_LIST;
    return this.postRequest(authUser, url, payload);
  },
  fetchIntentNames(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_INTENT_NAME_LIST;
    return this.postRequest(authUser, url, payload);
  },
  fetchTranscriptSummary(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_TRANSCRIPT_SUMMARY;
    return this.postRequest(authUser, url, payload);
  },

  addTranscript(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_ADD_TRANSCRIPT;
    return this.postRequest(authUser, url, payload);
  },

  removeTranscript(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_REMOVE_TRANSCRIPT;
    return this.postRequest(authUser, url, payload);
  },

  exportBlacklistedTopicMessages(authUser, payload) {
    const url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONTACT_REASONS_TOPIC_BLACKLISTS_TOPIC_MESSAGES_EXPORT;
    const headers = {};
    headers['Authorization'] = 'Bearer ' + authUser.accessToken;
    headers['Api-Configs'] = JSON.stringify(authUser.config.api.configs);
    if(authUser.sessionId) {
      headers['Auth-Host'] = authUser.authHost || "";
      headers['Auth-Session-Id'] = authUser.sessionId;
      headers['Auth-Product-Name'] = authUser.productName || "";
      headers['Auth-Options'] = authUser.authOptions || "";
    }

    let cancelTokenKey = url;
    if (this.cancelTokens[cancelTokenKey]) {
      // cancel request
      this.cancelTokens[cancelTokenKey].cancel();
    }
    this.cancelTokens[cancelTokenKey] = axios.CancelToken.source();

    let options = {
      timeout: 300000, // timeout in 5 mins
      headers: headers,
      cancelToken: this.cancelTokens[cancelTokenKey].token,
    };

    return axios.post(url, payload, options).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', 'blacklist.csv');
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  },

  exportTranscriptSearch(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_TRANSCRIPT_EXPORT;
    let headers = {};
    headers['Authorization'] = 'Bearer ' + authUser.accessToken;
    headers['Api-Configs'] = JSON.stringify(authUser.config.api.configs);
    if(authUser.sessionId) {
      headers['Auth-Host'] = authUser.authHost || "";
      headers['Auth-Session-Id'] = authUser.sessionId;
      headers['Auth-Product-Name'] = authUser.productName || "";
      headers['Auth-Options'] = authUser.authOptions || "";
    }

    let cancelTokenKey = url;
    if (this.cancelTokens[cancelTokenKey]) {
      // cancel request
      this.cancelTokens[cancelTokenKey].cancel();
    }
    this.cancelTokens[cancelTokenKey] = axios.CancelToken.source();

    let options = {
      timeout: 300000, // timeout in 5 mins
      headers: headers,
      cancelToken: this.cancelTokens[cancelTokenKey].token,
    };
    return axios.post(url, payload, options).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', 'transcripts.csv');
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  },

  fetchRunStats(user, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_RUN_STATS;
    return this.postRequest(user, url, payload);
  },

  fetchModelStats(user, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_MODEL_STATS;
    return this.postRequest(user, url, payload);
  },

  trafficManager(user, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_TRAFFIC_MANAGER;
    return this.postRequest(user, url, payload);
  },

  fetchMetrics(user, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_METRICS;
    return this.postRequest(user, url, payload);
  },

  fetchConfigIntentToHandoff(authUser) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONFIG_INTENTS_TO_HANDOFF;
    return this.getRequest(authUser, url);
  },

  updateConfigIntentToHandoff(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.ANALYTICS_CONFIG_INTENTS_TO_HANDOFF_UPDATE;
    return this.postRequest(authUser, url, payload);
  },
};
